import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('terrasIndigenasShapeFile');

export const check = () => useBasicAuth.checkToken();

export const findGeologiaShapeTerrasIndigenasFileById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeologiaShapeTerrasIndigenasFile = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeologiaShapeTerrasIndigenasFileByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateGeologiaShapeTerrasIndigenasFile = (fileRequest) => 
  axios.post(urlAPI + "/updateGeologiaShapeFileTerrasIndigenas" , JSON.stringify(fileRequest), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  

export const deleteGeologiaShapeTerrasIndigenasFile = (id) => 
  axios.delete(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });